import { createGlobalState } from "react-hooks-global-states";
import { User } from "./types";

export const useUser = createGlobalState<User | null>(null);
